import React, { useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Alert } from "reactstrap"

// Components
import AuthContainer from "./components/AuthContainer";
import LoginForm from "./login/LoginForm";
import LoginOtp from "./login/LoginOtp";
import LoginResult from "./login/LoginResult";

// Steps
const STEPS = {
  FORM: "form",
  OTP: "otp",
  RESULT: "result",
};

const Login = () => {
  // Meta title
  document.title = "เข้าสู่ระบบ | " + process.env.REACT_APP_CMS_TITLE;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(STEPS.FORM);
  const [userData, setUserData] = useState(null);

  // Check if session expired
  const sessionExpired = searchParams.get("reason") === "session_expired";

  const handleLoginSuccess = () => {
    const redirectTo = searchParams.get("redirect");
    navigate(redirectTo || "/");
  };

  const handleOtpRequired = (data) => {
    setUserData(data);
    setStep(STEPS.OTP);
  };

  const handleOtpSuccess = () => {
    setStep(STEPS.RESULT);
  };

  const haveForgot = (isHaveForgot) => {
    if (isHaveForgot) {
      return (
        <div className="d-flex justify-content-end mt-2">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/forgot-password");
            }}
            className="link"
          >
            ลืมรหัสผ่าน
          </a>
        </div>
      );
    }
    return null;
  };

  const haveRegister = (isHaveRegister) => {
    if (isHaveRegister) {
      return (
        <>
          <div className="text-center position-relative w-100">
            <div className="border-bottom position-absolute w-100 top-50"></div>
            <span className="px-2 position-relative text-xl text-gray-400" style={{ backgroundColor: "#f9fafb" }}>
              หรือ
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <h4 className="text-xl fw-semibold">ยังไม่มีบัญชี</h4>
            <a href="#" className="link">
              สมัครสมาชิก
            </a>
          </div>
        </>
      );
    }
    return <></>;
  };

  const renderStep = () => {
    switch (step) {
      case STEPS.OTP:
        return <LoginOtp userData={userData} onSuccess={handleOtpSuccess} />;
      case STEPS.RESULT:
        return <LoginResult userData={userData} />;
      case STEPS.FORM:
      default:
        return <LoginForm onSuccess={handleLoginSuccess} onOtpRequired={handleOtpRequired} haveForgot={haveForgot} haveRegister={haveRegister} />;
    }
  };

  return (
    <React.Fragment>
      <AuthContainer>
        <div className="w-full">{renderStep()}</div>
        {sessionExpired && (
          <Alert color="warning" className="mt-4">
            <div className="d-flex align-items-center gap-2">
              <i className="mdi mdi-clock-alert-outline"></i>
              <span>เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง</span>
            </div>
          </Alert>
        )}
      </AuthContainer>
    </React.Fragment>
  );
};

export default Login;

Login.propTypes = {
  // No props needed as we're using hooks
};
